import { PomodoroService } from "features/widget-workspace/service/PomodoroService";
import { PomodoroWidgetSettingsEntity } from "@lifeat/shared/data-models/widget/Pomodoro/PomodoroWidgetSettingsEntity";
import { GROUP_POMODORO_NODE, GROUP_POMODORO_SETTINGS_NODE, ROOMS_NODE } from "@lifeat/shared/rtdb-nodes/RtdbNodes";
import { PomodoroTimerType } from "@lifeat/shared/widget/PomodoroTimerTypes";
import { db } from "@firebase-local/firebase";
import { PomodoroAnalyticsService } from "./PomodoroAnalyticsService";

export function GuestPomodoroService(roomId: string, analytics: PomodoroAnalyticsService): PomodoroService {
    const fetchSettings = async (): Promise<PomodoroWidgetSettingsEntity | null> => {
        const path = `${ROOMS_NODE.name}/${roomId}/${GROUP_POMODORO_NODE.name}/${GROUP_POMODORO_SETTINGS_NODE.name}`;
        const ref = db.ref(path);
        const snapshot = await ref.once("value");
        return snapshot.val();
    };

    const logTimerStartEvent = (timerType: PomodoroTimerType, fromClick: boolean) => {
        analytics.log({
            eventType: "start",
            fromClick,
            timerType,
            timerMode: "guest",
        });
    };

    const logTimerEndEvent = (timerType: PomodoroTimerType) => {
        analytics.log({
            eventType: "end",
            timerType,
            timerMode: "guest",
        });
    };

    return {
        fetchSettings,
        logTimerStartEvent,
        logTimerEndEvent,
    };
}
